import type { AnySerializationAdapter } from '@tanstack/solid-router'

export const pluginSerializationAdapters: Array<AnySerializationAdapter> = []
export const hasPluginAdapters = false
